import Video from './videos/VideoC.mp4';
import Poster from './images/Aethel.png';
import './Bespoke.css';
import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

function Bespoke() {
    useEffect(() => {
        // Scroll to the top of the page when the component mounts
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className='bespoke-container'>
            <Helmet>
                <title>Bespoke Page</title>
                <meta name="description" content="Bespoke songwriting. Aethel can create songs for your special occasion or your special someone." />

                {/* Page-Specific Open Graph Tags */}
                <meta property="og:title" content="Bespoke Page - Aethel Music" />
                <meta property="og:description" content="Bespoke songwriting. Aethel can create songs for your special occasion or your special someone." />
                <meta property="og:image" content="%PUBLIC_URL%/images/AethelMedium.png" />
                <meta property="og:url" content="https://aethel.vercel.app/bespoke" />

                {/* Page-Specific Twitter Card Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Bespoke Page - Aethel Music" />
                <meta name="twitter:description" content="Bespoke songwriting. Aethel can create songs for your special occasion or your special someone." />
                <meta name="twitter:image" content="%PUBLIC_URL%/images/AethelMedium.png" />
            </Helmet>
            <h1 className="bespoke-title">Bespoke Songs</h1>
            <div className='bespoke-testimonials'>
                <div className='bespoke-video-container'>
                    <div className='bespoke-video'>
                        <video width="320" height="240" controls poster={Poster}>
                            <source src={Video} type="video/mp4" />

                            Your browser does not support the video tag.
                        </video></div>
                    <div className='bespoke-testimonial-container'><p className="quote">Æthel is available for both performance and bespoke songcrafting.
                        She also has material that could be used for sync licensing.<br />
                        If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.<br />Æthel is available for both performance and bespoke songcrafting.<br />
                        She also has material that could be used for sync licensing.<br />
                        If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.</p>
                        <p className='author' style={{ fontFamily: 'Island Moments', fontSize: 'xx-large' }}>Kristina Grace</p></div></div>

                <div className='bespoke-video-container'>
                    <div className='bespoke-video'>
                        <video width="320" height="240" controls poster={Poster}>
                            <source src={Video} type="video/mp4" />

                            Your browser does not support the video tag.
                        </video></div>
                    <div className='bespoke-testimonial-container'><p className="quote">Æthel is available for both performance and bespoke songcrafting.
                        She also has material that could be used for sync licensing.<br />
                        If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.<br />Æthel is available for both performance and bespoke songcrafting.<br />
                        She also has material that could be used for sync licensing.<br />
                        If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.</p>
                        <p className='author' style={{ fontFamily: 'Island Moments', fontSize: 'xx-large' }}>Kristina Grace</p></div></div>
                <div className='bespoke-video-container'>
                    <div className='bespoke-video'>
                        <video width="320" height="240" controls poster={Poster}>
                            <source src={Video} type="video/mp4" />

                            Your browser does not support the video tag.
                        </video></div>
                    <div className='bespoke-testimonial-container'><p className="quote">Æthel is available for both performance and bespoke songcrafting.
                        She also has material that could be used for sync licensing.<br />
                        If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.<br />Æthel is available for both performance and bespoke songcrafting.<br />
                        She also has material that could be used for sync licensing.<br />
                        If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.</p>
                        <p className='author' style={{ fontFamily: 'Island Moments', fontSize: 'xx-large' }}>Kristina Grace</p></div></div>
            </div>
            <div className='bespoke-text-btn-container'>
                <h2 className='sub-heading'>ÆthelSong</h2>
                <p className="bespoke-text" >Æthel is available for both performance and bespoke songcrafting.
                    She also has material that could be used for sync licensing.
                    If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.<br />Æthel is available for both performance and bespoke songcrafting.
                    She also has material that could be used for sync licensing.<br />
                    If you would like to contact Æthel for any of these reasons, please click on the button below to contact her.</p>
                <div id='bespoke-btn'>
                    <Link to="/contact" id='contact-button'><button>Enquire Now</button></Link></div>

            </div>
        </div>

    );
}

export default Bespoke;
